// extracted by mini-css-extract-plugin
module.exports = {"c-title":"BookingWidgetSectionHeader_c-title__d7Mlp"};